import { FunctionComponent } from 'react'

import dynamic from 'next/dynamic'

import useArticleSchema from '@hooks/useArticleSchema'
import { CookWidget, JSONTypeForCookWidget } from '@widgets/types'

interface TextBodyProps {
  text?: string
}

const HTMLView = dynamic(() => import('@components/HTMLView'))

export const allowedHtmlTags = [
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'p',
  'ul',
  'ol',
  'li',
  'em',
  'strong',
  'a',
  'table',
  'tbody',
  'tr',
  'td',
  'sub',
  'sup',
  'strike',
  'u',
  'br',
  'i',
]

const TextBody: FunctionComponent<TextBodyProps> = ({ text }) => {
  useArticleSchema({ text })

  if (!text) {
    return null
  }

  return <HTMLView content={text} allowedHtmlTags={allowedHtmlTags} />
}

const widget = {
  kind: ['widget', 'text-body'],
  component: TextBody,
} as const satisfies CookWidget

export type WidgetType = typeof widget

export type JSONWidgetType = JSONTypeForCookWidget<WidgetType>

export default widget
